import type { HTMLAttributes } from 'react';

const ring =
  'rounded-full border-[3px] border-red-200 border-t-red-600 dark:border-red-900/45 dark:border-t-red-400 animate-spin';

/** Кольцо без подписи (кнопки, иконки). */
export function VndLoadingSpinner({ className = 'h-11 w-11' }: { className?: string }) {
  return <span className={`inline-block shrink-0 ${ring} ${className}`} aria-hidden />;
}

/** Компактное кольцо для тёмных кнопок (логин и т.п.). */
export function VndButtonSpinner({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <span
      className={`inline-block shrink-0 rounded-full border-2 border-red-300/45 border-t-red-100 animate-spin ${className}`}
      aria-hidden
    />
  );
}

type VndPageLoadingProps = HTMLAttributes<HTMLDivElement> & {
  /** Высота как у блока таблицы */
  fillTable?: boolean;
};

/** Красный спиннер и текст «Загрузка» — единый вид для страниц и таблиц. */
export default function VndPageLoading({ className = '', fillTable, ...rest }: VndPageLoadingProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex flex-col items-center justify-center gap-3 ${fillTable ? 'min-h-[280px] py-10' : 'py-14'} ${className}`}
      {...rest}
    >
      <VndLoadingSpinner className="h-11 w-11" />
      <p className="text-sm font-medium text-red-600 dark:text-red-400">Загрузка</p>
    </div>
  );
}

/** Полноэкранная загрузка (лейаут до профиля). */
export function VndFullscreenLoading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-gray-50 dark:bg-gray-950">
      <VndLoadingSpinner className="h-12 w-12" />
      <p className="text-sm font-medium text-red-600 dark:text-red-400">Загрузка</p>
    </div>
  );
}
